<template>
  <div id="app">
    <RebalanceCalculator :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import RebalanceCalculator from "./components/RebalanceCalculator.vue";

export default {
  name: "App",
  components: {
    RebalanceCalculator,
  },
};
</script>

<style>
#app {
}
</style>
